import { render } from "./PrenotazioniSenior.vue?vue&type=template&id=36736a98&scoped=true"
import script from "./PrenotazioniSenior.vue?vue&type=script&lang=js"
export * from "./PrenotazioniSenior.vue?vue&type=script&lang=js"

import "./PrenotazioniSenior.vue?vue&type=style&index=0&id=36736a98&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36736a98"]])

export default __exports__